import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { createDayjs } from '@chiroup/core/functions/time';
import { Dayjs } from 'dayjs';

const locationService = () => {
  const getLocation = async (path: string): Promise<any> => {
    return ChiroUpAPI.get('api-noauth', `/location/${path}`, {});
  };

  const getAvailability = async ({
    path,
    provider,
    year,
    month,
    treatment,
    timezone,
  }: {
    path: string;
    provider: string | null;
    year: string;
    month: string;
    treatment: number | null;
    timezone: string;
  }): Promise<{
    [key: number]: {
      [key: string]: {
        date: string;
        startTime: Dayjs;
        endTime: Dayjs;
        provider: string;
        duration: number;
      }[];
    };
  }> => {
    const res = (await ChiroUpAPI.get(
      'api-noauth',
      `/location/${path}/availability`,
      {
        queryParams: {
          path,
          provider,
          year,
          month,
          treatment,
        },
      },
    )) as {
      [key: number]: {
        [key: string]: {
          date: string;
          startTime: string;
          endTime: string;
          provider: string;
          duration: number;
        }[];
      };
    };
    return Object.entries(res).reduce(
      (
        acc: {
          [key: string]: {
            [key: string]: {
              date: string;
              startTime: Dayjs;
              endTime: Dayjs;
              provider: string;
              duration: number;
            }[];
          };
        },
        [key, value],
      ) => {
        acc[key] = Object.entries(value).reduce(
          (
            acc: {
              [key: string]: {
                date: string;
                startTime: Dayjs;
                endTime: Dayjs;
                provider: string;
                duration: number;
              }[];
            },
            [key, value],
          ) => {
            acc[key] = value.map((v) => ({
              ...v,
              startTime: createDayjs({
                datetime: v.startTime,
                timezone,
              }) as Dayjs,
              endTime: createDayjs({ datetime: v.endTime, timezone }) as Dayjs,
            }));
            return acc;
          },
          {},
        );
        return acc;
      },
      {},
    );
  };

  const getAppointments = async (path: string): Promise<any> => {
    return ChiroUpAPI.get('api', `/appointment/${path}`, {});
  };

  const cancelAppointment = async (
    appointmentId: string,
    reason: string,
  ): Promise<void> => {
    return ChiroUpAPI.del('api', `/appointment/${appointmentId}/${reason}`, {});
  };

  return {
    getLocation,
    getAvailability,
    getAppointments,
    cancelAppointment,
  };
};

export default locationService();
